import { render } from "./EditRoom.vue?vue&type=template&id=36e07bc4"
import script from "./EditRoom.vue?vue&type=script&lang=ts"
export * from "./EditRoom.vue?vue&type=script&lang=ts"
script.render = render

export default script